import React from "react";
import {
  EditOutlined, TagOutlined, HourglassOutlined, CheckCircleOutlined,
  DollarOutlined, ShoppingOutlined, CarOutlined, HomeOutlined,
  PauseCircleOutlined, CloseCircleOutlined, TrophyOutlined,
} from "@ant-design/icons";
import watiLogo from "../../assets/wati_logo_only.png";

export const PIPELINE_COLUMNS = [
  {
    key: "in_chat",
    label: "All Chats",
    color: "#1677ff",
    icon: <img src={watiLogo} alt="WATI" style={{ width: 15, height: 15, objectFit: "contain", display: "inline-block" }} />,
    isChat: true,
  },
  { key: "draft",                         label: "Draft",                        color: "#8c8c8c", icon: <EditOutlined />,         statuses: ["draft"] },
  { key: "waiting_for_price",             label: "Waiting For Price",            color: "#1677ff", icon: <TagOutlined />,           statuses: ["waiting_for_price"] },
  { key: "waiting_customer_confirmation", label: "Waiting Confirmation",         color: "#faad14", icon: <HourglassOutlined />,     statuses: ["waiting_customer_confirmation"] },
  { key: "confirmed_waiting_payment",     label: "Confirmed · Awaiting Payment", color: "#13c2c2", icon: <CheckCircleOutlined />,   statuses: ["confirmed_waiting_payment"] },
  { key: "paid",                          label: "Paid",                         color: "#52c41a", icon: <DollarOutlined />,        statuses: ["paid"] },
  { key: "waiting_purchase",              label: "Waiting Purchase",             color: "#722ed1", icon: <ShoppingOutlined />,      statuses: ["waiting_purchase"] },
  { key: "purchased",                     label: "Purchased",                    color: "#2f54eb", icon: <ShoppingOutlined />,      statuses: ["purchased"] },
  { key: "out_for_delivery",              label: "Out For Delivery",             color: "#fa8c16", icon: <CarOutlined />,           statuses: ["out_for_delivery"] },
  { key: "completed",                     label: "Completed",                    color: "#389e0d", icon: <TrophyOutlined />,        statuses: ["completed", "delivered"] },
  { key: "parked",                        label: "Parked",                       color: "#8c8c8c", icon: <PauseCircleOutlined />,   statuses: ["on_hold", "postponed", "parked"] },
  { key: "cancelled",                     label: "Cancelled",                    color: "#ff4d4f", icon: <CloseCircleOutlined />,   statuses: ["cancelled"] },
];

export function groupQueriesByStatus(tasks) {
  return PIPELINE_COLUMNS.reduce((acc, col) => {
    acc[col.key] = col.isChat ? [] : tasks.filter(t => col.statuses?.includes(t.status));
    return acc;
  }, {});
}

export const URGENCY_CFG = {
  1: { color: "#595959", pill: "#f0f0f0", cardBg: "transparent",              label: "1 · Low" },
  2: { color: "#1677ff", pill: "#e6f4ff", cardBg: "rgba(22,119,255,0.04)",    label: "2 · Normal" },
  3: { color: "#d48806", pill: "#fffbe6", cardBg: "rgba(250,173,20,0.06)",    label: "3 · Medium" },
  4: { color: "#d4380d", pill: "#fff2e8", cardBg: "rgba(255,122,0,0.08)",     label: "4 · High" },
  5: { color: "#cf1322", pill: "#fff1f0", cardBg: "rgba(255,77,79,0.12)",     label: "5 · Critical" },
};
